(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 1780:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(674);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ThemeContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1720);

var ThemeContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);


/***/ }),

/***/ 8418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(1720));
var _router = __webpack_require__(6273);
var _router1 = __webpack_require__(387);
var _useIntersection = __webpack_require__(7190);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === 'A';
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
function Link(props) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var p = props.prefetch !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, props.href, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: props.as ? (0, _router).resolveHref(router, props.as) : resolvedAs || resolvedHref
        };
    }, [
        router,
        props.href,
        props.as
    ]), href = ref2.href, as = ref2.as;
    var children = props.children, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale;
    if (typeof children === 'string') {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (false) {} else {
        child = _react.default.Children.only(children);
    }
    var childRef = child && typeof child === 'object' && child.ref;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: '200px'
    }), 2), setIntersectionRef = ref1[0], isVisible = ref1[1];
    var setRef = _react.default.useCallback(function(el) {
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === 'function') childRef(el);
            else if (typeof childRef === 'object') {
                childRef.current = el;
            }
        }
    }, [
        childRef,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
        var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (child.props && typeof child.props.onClick === 'function') {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        }
    };
    childProps.onMouseEnter = function(e) {
        if (child.props && typeof child.props.onMouseEnter === 'function') {
            child.props.onMouseEnter(e);
        }
        if ((0, _router).isLocalURL(href)) {
            prefetch(router, href, as, {
                priority: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (props.passHref || child.type === 'a' && !('href' in child.props)) {
        var curLocale1 = typeof locale !== 'undefined' ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return(/*#__PURE__*/ _react.default.cloneElement(child, childProps));
}
var _default = Link;
exports["default"] = _default; //# sourceMappingURL=link.js.map


/***/ }),

/***/ 7190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(1720);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ''
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./styles/globals.scss
var globals = __webpack_require__(4831);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./context/ThemeContext.js
var ThemeContext = __webpack_require__(306);
;// CONCATENATED MODULE: ./components/ThemeSelector.js



function ThemeSelector() {
    var ref = (0,compat_module.useContext)(ThemeContext/* ThemeContext */.N), dark = ref.dark, setDark = ref.setDark;
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        style: {
            height: '50px',
            display: 'flex',
            margin: '0 auto',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            transform: dark ? 'rotate(360deg)' : 'rotate(0deg)',
            transition: 'transform 0.5s ease-in-out'
        },
        onClick: function() {
            return setDark(!dark);
        },
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
            width: "25",
            height: "25",
            viewBox: "0 0 25 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                    style: {
                        opacity: dark ? '1' : '0',
                        transition: 'opacity 0.5s ease-in-out'
                    },
                    d: "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79zM1 10.5h3v2H1zM11 .55h2V3.5h-2zm8.04 2.495l1.408 1.407-1.79 1.79-1.407-1.408zm-1.8 15.115l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm-1 4h2v2.95h-2zm-7.45-.96l1.41 1.41 1.79-1.8-1.41-1.41z"
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                    style: {
                        opacity: dark ? '0' : '1',
                        transition: 'opacity 0.5s ease-in-out'
                    },
                    d: "M9.37,5.51C9.19,6.15,9.1,6.82,9.1,7.5c0,4.08,3.32,7.4,7.4,7.4c0.68,0,1.35-0.09,1.99-0.27C17.45,17.19,14.93,19,12,19 c-3.86,0-7-3.14-7-7C5,9.07,6.81,6.55,9.37,5.51z M12,3c-4.97,0-9,4.03-9,9s4.03,9,9,9s9-4.03,9-9c0-0.46-0.04-0.92-0.1-1.36 c-0.98,1.37-2.58,2.26-4.4,2.26c-2.98,0-5.4-2.42-5.4-5.4c0-1.81,0.89-3.42,2.26-4.4C12.92,3.04,12.46,3,12,3L12,3z"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./icons/arrow-down.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/compat_module.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path || (_path = /*#__PURE__*/compat_module.createElement("path", {
    d: "M24 24H0V0h24v24z",
    fill: "none",
    opacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/compat_module.createElement("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
  })));
};

/* harmony default export */ var arrow_down = (SvgArrowDown);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/Layout.js






function Layout(param) {
    var children = param.children;
    var ref = (0,compat_module.useState)(false), open = ref[0], setOpen = ref[1];
    var router = (0,next_router.useRouter)();
    var handleNavigationToggle = function(e) {
        e.preventDefault();
        setOpen(!open);
    };
    var links = [
        {
            href: '/',
            label: 'Home'
        },
        {
            href: '/about',
            label: 'About'
        },
        {
            href: '/blog',
            label: 'Blog'
        },
        {
            href: '/contact',
            label: 'Contact'
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("nav", {
                className: "navigation",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_link["default"], {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                            className: "navigation__logo",
                            children: "{TobyHagan}"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                        className: 'navigation__list',
                        style: {
                            top: open ? '50px' : '-1000%'
                        },
                        children: [
                            links.map(function(link) {
                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                                    onClick: function() {
                                        router.push(link.href);
                                        setOpen(false);
                                    },
                                    className: "navigation__item",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_link["default"], {
                                        href: link.href,
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                            className: "navigation__link",
                                            children: link.label
                                        })
                                    })
                                }, link.href);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                className: "navigation__item",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ThemeSelector, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                        "aria-label": "Toggle navigation",
                        name: "navigation-toggle",
                        onClick: handleNavigationToggle,
                        className: "navigation__toggle",
                        style: {
                            transition: 'transform 0.5s ease',
                            transform: open ? 'rotateX(180deg)' : 'rotateX(0deg)'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(arrow_down, {})
                    })
                ]
            }),
            children
        ]
    }));
};

;// CONCATENATED MODULE: ./components/Cookie.js


function Cookies() {
    var fadeOut = function fadeOut() {
        var banner = document.querySelector('.cookie-banner');
        if (banner) {
            banner.style.transition = 'all 0.5s ease-out';
            banner.style.transform = 'translateY(100%)';
        }
    };
    var ref = (0,compat_module.useState)(), needsCookies = ref[0], setNeedsCookies = ref[1];
    (0,compat_module.useEffect)(function() {
        var acceptsCookies = localStorage.getItem('acceptsCookies');
        if (!acceptsCookies) {
            setNeedsCookies(true);
        }
        setTimeout(fadeOut, 4500);
        setTimeout(function() {
            localStorage.setItem('acceptsCookies', true);
            setNeedsCookies(false);
        }, 5000);
    }, [
        needsCookies
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        children: needsCookies && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "cookie-banner",
            style: {
                position: 'fixed',
                zIndex: '99999',
                bottom: '0',
                left: '0',
                backgroundColor: '#333',
                color: 'white',
                padding: '1em',
                textAlign: 'center',
                width: '100vw'
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                    style: {
                        width: '70%',
                        margin: 'auto'
                    },
                    children: "This website uses cookies to enhance your experience. By continuing to browse the site you are agreeing to our use of cookies."
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                    style: {
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        margin: '.75em'
                    },
                    onClick: function() {
                        localStorage.setItem('acceptsCookies', true);
                        setNeedsCookies(false);
                    },
                    children: "Accept"
                })
            ]
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./components/utils/pageView.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function pageView(route) {
    return _pageView.apply(this, arguments);
}
function _pageView() {
    _pageView = _asyncToGenerator(runtime_default().mark(function _callee(route) {
        var res, ipAddress, sent, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("https://api.ipify.org?format=json");
                case 2:
                    res = _ctx.sent;
                    _ctx.next = 5;
                    return res.json();
                case 5:
                    ipAddress = _ctx.sent;
                    ipAddress = ipAddress.ip;
                    _ctx.next = 9;
                    return fetch('/api/pageView', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            path: route,
                            ip: ipAddress
                        })
                    });
                case 9:
                    sent = _ctx.sent;
                    _ctx.next = 12;
                    return sent.json();
                case 12:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _pageView.apply(this, arguments);
}

;// CONCATENATED MODULE: ./pages/_app.js










function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useState)(null), dark = ref[0], setDark = ref[1];
    var themeValue = (0,compat_module.useMemo)(function() {
        return {
            dark: dark,
            setDark: setDark
        };
    }, [
        dark,
        setDark
    ]);
    (0,compat_module.useEffect)(function() {
        pageView(router.asPath);
    }, [
        router.asPath
    ]);
    (0,compat_module.useEffect)(function() {
        var darkPreference = localStorage.getItem('dark');
        if (!darkPreference) {
            var systemPreference = window.matchMedia('(prefers-color-scheme: dark)');
            if (systemPreference.matches) {
                setDark(true);
                localStorage.setItem('dark', true);
            } else {
                setDark(false);
                localStorage.setItem('dark', false);
            }
        } else {
            if (darkPreference === 'true') {
                setDark(true);
            } else if (darkPreference === 'false') {
                setDark(false);
            }
        }
    }, [
        setDark
    ]);
    (0,compat_module.useEffect)(function() {
        if (dark) {
            document.body.classList.add('dark');
            localStorage.setItem('dark', true);
        } else {
            document.body.classList.remove('dark');
            localStorage.setItem('dark', false);
        }
    }, [
        dark,
        setDark
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ThemeContext/* ThemeContext.Provider */.N.Provider, {
        value: themeValue,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "app__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(script["default"], {
                    id: "localBusiness",
                    strategy: "afterInteractive",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "LocalBusiness",
                            name: "Toby Hagan",
                            address: {
                                "@type": "PostalAddress",
                                addressLocality: "Christiansburg",
                                addressRegion: "VA",
                                postalCode: "24073",
                                addressCountry: "US",
                                streetAddress: "Christiansburg, Va"
                            },
                            url: "https://tobyhagan.com",
                            image: "https://tobyhagan.com/images/toby.jpg",
                            priceRange: "$$",
                            telephone: "+15402008108",
                            openingHoursSpecification: [
                                {
                                    "@type": "OpeningHoursSpecification",
                                    dayOfWeek: "Saturday",
                                    opens: "00:00",
                                    closes: "23:59"
                                },
                                {
                                    "@type": "OpeningHoursSpecification",
                                    dayOfWeek: "Sunday",
                                    opens: "00:00",
                                    closes: "00:00"
                                }, 
                            ]
                        })
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(head["default"], {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            charSet: "utf-8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            name: "theme-color",
                            content: "#1e2227"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            name: "viewport",
                            content: "width=device-width, initial-scale=1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            name: "robots",
                            content: "index, follow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            name: "googlebot",
                            content: "index, follow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            name: "referrer",
                            content: "origin"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            name: "copyright",
                            content: "Toby Hagan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("meta", {
                            property: "og:site_name",
                            content: "Toby Hagan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("link", {
                            rel: "alternate",
                            type: "application/rss+xml",
                            title: "RSS Feed for tobyhagan.com",
                            href: "/atom.xml"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("link", {
                            rel: "manifest",
                            href: "/manifest.webmanifest"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("link", {
                            rel: "icon",
                            href: "/favicon.ico"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("link", {
                            rel: "preconnect",
                            href: "https://www.googletagmanager.com/"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Layout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Component, _objectSpread({}, pageProps)),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Cookies, {})
                    ]
                })
            ]
        })
    }));
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 4831:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8418)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(1780), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);